import Navigation from "./navigation";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Navigation />
      <Toaster />
    </>
  );
}

export default App;
